import { http } from "./http";

export const propertyLiensApi = {
  // params sugeridos: { auction_property_id, status, limit, offset }
  list: (params) => http.get("/property-liens", { params }).then((r) => r.data),

  getById: (id) => http.get(`/property-liens/${id}`).then((r) => r.data),

  // payload esperado (model/service):
  // { auction_property_id, lien_type?, amount?, recorded_at?, status?, source_url?, notes? }
  create: (payload) =>
    http.post("/property-liens", payload).then((r) => r.data),

  update: (id, payload) =>
    http.put(`/property-liens/${id}`, payload).then((r) => r.data),

  remove: (id) => http.delete(`/property-liens/${id}`).then((r) => r.data),
};
